const initialState = {
  banner: {
    visible: false,
    message: "",
    title: "",
  },
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case "SET_BANNER_POPUP":
      return { ...state, banner: { ...action.payload } };
    case "REMOVE_BANNER_POPUP":
      return { ...state, banner: { ...initialState.banner } };
    default:
      return state;
  }
};
